export const hcpDCRControlStyles = {
	typeLabel: {
		color: 'text.secondary',
		justifyContent: 'center',
		paddingTop: 0.5,
		marginBottom: 0.5,
		fontSize: '0.75rem'
	},

	dataChangeRequestButton: {
		textTransform: 'none',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		minWidth: 'max-content',
		height: '32px',
		fontWeight: 700,
		lineHeight: 1
	}
};
